// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3L9lU","icon":"styles_icon__yI3pA","edit":"styles_edit__qvoGe","save":"styles_save__2XIky","input":"styles_input__1d24h"};